import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import RoleRoute from "@/components/RoleRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ForgotPin from "@/pages/ForgotPin";
import CustomerRegister from "@/pages/CustomerRegister";
import BusinessRegister from "@/pages/BusinessRegister";

import CustomerLayout from "@/pages/customer/CustomerLayout";import CustomerHome from "@/pages/customer/Home";
import CustomerBusinesses from "@/pages/customer/Businesses";
import BusinessProfile from "@/pages/customer/BusinessProfile";
import QRScreen from "@/pages/customer/QRScreen";
import ScanBusiness from "@/pages/customer/ScanBusiness";
import ClaimAccount from "@/pages/customer/ClaimAccount";
import CustomerNotifications from "@/pages/customer/Notifications";
import Discover from "@/pages/customer/Discover";
import Identity from "@/pages/customer/Identity";
import LinkCard from "@/pages/customer/LinkCard";

import StaffLayout from "@/pages/staff/StaffLayout";
import StaffHome from "@/pages/staff/StaffHome";
import ScanFlow from "@/pages/staff/ScanFlow";
import StaffToday from "@/pages/staff/Today";
import CardFlow from "@/pages/staff/CardFlow";

import BusinessLayout from "@/pages/business/BusinessLayout";
import BizDashboard from "@/pages/business/Dashboard";
import BizCustomers from "@/pages/business/Customers";
import BizTransactions from "@/pages/business/Transactions";
import BizStaff from "@/pages/business/Staff";
import BizBranches from "@/pages/business/Branches";
import BizReports from "@/pages/business/Reports";
import BizQRCodes from "@/pages/business/QRCodes";
import BizProfile from "@/pages/business/BusinessProfile";
import AdminPhysicalCards from "@/pages/admin/PhysicalCards";

import AdminLayout from "@/pages/admin/AdminLayout";
import Sessions from "@/pages/security/Sessions";
import LoyaltyEngine from "@/pages/business/LoyaltyEngine";
import CustomerRewards from "@/pages/customer/Rewards";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminBusinesses from "@/pages/admin/Businesses";
import AdminBusinessDetail from "@/pages/admin/BusinessDetail";
import AdminCustomers from "@/pages/admin/Customers";
import AdminCustomerDetail from "@/pages/admin/CustomerDetail";
import AdminTransactions from "@/pages/admin/Transactions";
import AdminFraud from "@/pages/admin/FraudFlags";
import AdminUsers from "@/pages/admin/Users";
import AdminConfig from "@/pages/admin/Configurations";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-center" theme="light" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot" element={<ForgotPin />} />
            <Route path="/register" element={<CustomerRegister />} />
            <Route path="/claim" element={<ClaimAccount />} />
            <Route path="/business/register" element={<BusinessRegister />} />

            <Route path="/app" element={<RoleRoute roles={["customer"]}><CustomerLayout /></RoleRoute>}>
              <Route index element={<CustomerHome />} />
              <Route path="businesses" element={<CustomerBusinesses />} />
              <Route path="discover" element={<Discover />} />
              <Route path="businesses/:id" element={<BusinessProfile />} />
              <Route path="scan" element={<ScanBusiness />} />
              <Route path="qr" element={<QRScreen />} />
              <Route path="identity" element={<Identity />} />
              <Route path="link-card" element={<LinkCard />} />
              <Route path="notifications" element={<CustomerNotifications />} />
              <Route path="rewards" element={<CustomerRewards />} />
              <Route path="security" element={<Sessions />} />
            </Route>

            <Route path="/staff" element={<RoleRoute roles={["cashier", "business_owner", "business_manager"]}><StaffLayout /></RoleRoute>}>
              <Route index element={<StaffHome />} />
              <Route path="scan" element={<ScanFlow />} />
              <Route path="card" element={<CardFlow />} />
              <Route path="today" element={<StaffToday />} />
            </Route>

            <Route path="/business" element={<RoleRoute roles={["business_owner", "business_manager"]}><BusinessLayout /></RoleRoute>}>
              <Route index element={<BizDashboard />} />
              <Route path="customers" element={<BizCustomers />} />
              <Route path="loyalty" element={<Navigate to="/business/engine" replace />} />
              <Route path="engine" element={<LoyaltyEngine />} />
              <Route path="engagement" element={<Navigate to="/business/engine" replace />} />
              <Route path="rewards" element={<Navigate to="/business/engine" replace />} />
              <Route path="transactions" element={<BizTransactions />} />
              <Route path="staff" element={<BizStaff />} />
              <Route path="profile" element={<BizProfile />} />
              <Route path="branches" element={<BizBranches />} />
              <Route path="qr" element={<BizQRCodes />} />
              <Route path="reports" element={<BizReports />} />
              <Route path="security" element={<Sessions />} />
            </Route>

            <Route path="/admin" element={<RoleRoute roles={["admin"]}><AdminLayout /></RoleRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="businesses" element={<AdminBusinesses />} />
              <Route path="businesses/:id" element={<AdminBusinessDetail />} />
              <Route path="customers" element={<AdminCustomers />} />
              <Route path="customers/:id" element={<AdminCustomerDetail />} />
              <Route path="cards" element={<AdminPhysicalCards />} />
              <Route path="transactions" element={<AdminTransactions />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="config" element={<AdminConfig />} />
              <Route path="modules" element={<Navigate to="/admin/config" replace />} />
              <Route path="fraud" element={<AdminFraud />} />
              <Route path="security" element={<Sessions />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
